module.exports = __webpack_public_path__ + "static/media/kw_logo.3ce1e928.png";